import { PREFERENCE_KEYS } from 'types/preferenceTypes';
import { useOrganizationWidePreferences } from './useOrganizationWidePreferences';
import { useCallback } from 'react';

const EMPTY_PREFERENCE = {};
/** a Organization Preference is a preference that is tenant wide, and is applied to all users */
export const useOrganizationWidePreference = <TValue>({ key }: { key?: PREFERENCE_KEYS }) => {
  const {
    data,
    loading,
    setPreference: _set,
    deletePreference: _delete,
  } = useOrganizationWidePreferences<TValue>();

  const setPreference = useCallback(
    (value: TValue) => {
      if (!key) {
        return Promise.reject('no preference key provided');
      }
      return _set(key, value);
    },
    [_set, key]
  );

  const deletePreference = useCallback(() => {
    if (!key) {
      return Promise.reject('no preference key provided');
    }
    return _delete(key);
  }, [_delete, key]);

  const clearPreference = useCallback(() => {
    return setPreference({} as TValue);
  }, [setPreference]);

  return {
    value: (data?.find(({ key: k }) => k === key)?.value ?? EMPTY_PREFERENCE) as TValue,
    loading,
    setPreference,
    deletePreference,
    clearPreference,
  };
};
